export const environment = {
    //production: true
    //domain: 'https://www.pla22agurus.com:2083/',
    //domain: 'https://prepro-api.gurushonduras.com/',
    //domain: 'https://api.gurushonduras.com/',
    domain: 'https://des-api.gurushonduras.com/',
    domainPRD: 'https://www.pla22agurus.com:2083/',
    url_amazon_s3: 'https://plazza.s3.us-east-2.amazonaws.com/',
};